<div class="day-node-wrapper">
  <div>{{ dayInMonth }}</div>
  <div
    class="status-indicator"
    [ngClass]="color"
  ></div>
</div>
